/**
 * @generated SignedSource<<bafa5783606d16011b4fb8375c71e6bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PolFileUploadStatus = "ERROR" | "NOT_STARTED" | "SCANNING" | "SUCCESS" | "WAITING_FOR_JOB" | "%future added value";
export type PolUploadInput = {
  clientMutationId?: string | null | undefined;
  polFileUploadId: UUID;
};
export type PolFileUploadCondition = {
  fileName?: string | null | undefined;
  fileSize?: BigInt | null | undefined;
  galleryAssetId?: UUID | null | undefined;
  gwtUserId?: UUID | null | undefined;
  rowId?: UUID | null | undefined;
  tossKey?: string | null | undefined;
  tossUrl?: string | null | undefined;
  uploadError?: string | null | undefined;
  uploadStatus?: PolFileUploadStatus | null | undefined;
};
export type usePolUpload_retryMutation$variables = {
  condition?: PolFileUploadCondition | null | undefined;
  input: PolUploadInput;
};
export type usePolUpload_retryMutation$data = {
  readonly retryPolUpload: {
    readonly clientMutationId: string | null | undefined;
    readonly query: {
      readonly polFileUploads: {
        readonly nodes: ReadonlyArray<{
          readonly fileName: string;
          readonly galleryAssetId: UUID;
          readonly rowId: UUID;
          readonly tossUrl: string;
          readonly uploadError: string;
          readonly uploadStatus: PolFileUploadStatus;
        }>;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type usePolUpload_retryMutation = {
  response: usePolUpload_retryMutation$data;
  variables: usePolUpload_retryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "condition"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "condition",
    "variableName": "condition"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "galleryAssetId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tossUrl",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uploadError",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uploadStatus",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "usePolUpload_retryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "PolUploadPayload",
        "kind": "LinkedField",
        "name": "retryPolUpload",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "PolFileUploadsConnection",
                "kind": "LinkedField",
                "name": "polFileUploads",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PolFileUpload",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "usePolUpload_retryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "PolUploadPayload",
        "kind": "LinkedField",
        "name": "retryPolUpload",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "PolFileUploadsConnection",
                "kind": "LinkedField",
                "name": "polFileUploads",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PolFileUpload",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2a2155d275912ca18785188ad5f4aaa2",
    "id": null,
    "metadata": {},
    "name": "usePolUpload_retryMutation",
    "operationKind": "mutation",
    "text": "mutation usePolUpload_retryMutation(\n  $input: PolUploadInput!\n  $condition: PolFileUploadCondition\n) {\n  retryPolUpload(input: $input) {\n    query {\n      polFileUploads(condition: $condition) {\n        nodes {\n          galleryAssetId\n          fileName\n          tossUrl\n          uploadError\n          uploadStatus\n          rowId\n          id\n        }\n      }\n      id\n    }\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "279495716469f2e624a7261c6a6aa32a";

export default node;
